const GoldenWaltzFollow = {
    name: "Golden Waltz",
    bpm: 186,
    signature: "6/8",
    introMeasures: 8,
    pattern: [

    ]
};

export default GoldenWaltzFollow;